import { GridContainer, ZoneB } from "../../App/Pages/styles/Grid.styled";
import React from "react";
import { MapsWidget } from "../../Widgets/MapsWidget";



const Map = () => {
  return (
    <>
      <GridContainer>
        <ZoneB>
          <MapsWidget />
        </ZoneB>

      </GridContainer>
    </>
  );
}

export default Map;